import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerPwaServiceWorker } from './lib/pwa';
import './styles.css';
import './features.css';
import './war-room.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerPwaServiceWorker();
